import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';

// Simple loading state (can be expanded with a service)
let activeRequests = 0;

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  activeRequests++;

  return next(req).pipe(
    finalize(() => {
      activeRequests--;
    })
  );
};

export function isLoading(): boolean {
  return activeRequests > 0;
}
